import React from 'react';

export function BirthdayCakeIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path stroke="#000" strokeWidth="1.5" d="M4 10h12v8H4z" />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M2 10h15.999M6 6v4M9.999 6v4M13.999 6v4"
      />
    </svg>
  );
}
